import React, { useEffect, useState } from 'react';
import "../../../css/components/OrderInfo/EditOrderModal/EditOrderModal.css";

import { Message } from '../../../utils/Message';
import { delay, formatTaiwanDate } from '../../../utils';
import { EditRecordModalList } from '../../../constants';

import { getDeliver } from '../../../service/api/Deliver/apiDeliver';
import { updateDeliveryRedcord } from '../../../service/api/DeliveryRecord/apiDeliveryRecord';
import { updateOrderDeliver } from '../../../service/api/Order/apiOrder';


const EditRecordModal = ({ record, onClose, setRecordsData }) => {
  // if (!order) return null;

  const [deliversData, setDeliversData] = useState([]);
  const [form, setForm] = useState({
    id: record?.id,
    deliverId: record?.deliverId,
    deliverName: record?.deliverName,
    deliveryDate: record?.deliveryDate,
    drivingKm: record?.drivingKm,
    mapUrl: record?.mapUrl,
    drivingTime: record?.drivingTime,
    weight: record?.weight,
    drivingKm: record?.drivingKm,
    carbonReduction: record?.carbonReduction,
    status: record?.status,
    orderId: record?.orderId,
    removedOrderId: [],
  });

  // 🔹 新增：標籤 state（用 orderId array 生成）
  const [tags, setTags] = useState(
    Array.isArray(record?.orderId) ? record.orderId.map((id, index) => ({ id, label: `標籤 ${index + 1}` })) : []
  );

  useEffect(() => {
    getDeliver()
      .then(response => {
        if (response?.status === 200) {
          console.log(response)
          setDeliversData(response.data.result);
        }
      });
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(form)
    const response = await updateDeliveryRedcord(form);
    console.log(response.data);
    if (response.status === 200) {
      Message('紀錄更新成功');
      await delay(1)

      const response_t = await updateOrderDeliver({
        deliverId: form?.deliverId,
        deliverName: form?.deliverName,
        orderId: form?.orderId,
        removedOrderId: form?.removedOrderId
      });
      if (response_t.status === 200) {
        Message('訂單司機更新成功');
        await delay(1);
        onClose(null);
        setRecordsData(prev => prev.map(o => o.id === form.id ? response.data.result : o));
      }
    }
  };

  // 🔹 新增：刪除標籤功能
  const handleRemoveTag = (id) => {
    setTags(prev => prev.filter(tag => tag.id !== id));
    setForm(prev => (
      {
        ...prev,
        orderId: prev.orderId.filter(tag => tag !== id),
        removedOrderId: [...(prev.removedOrderId || []), ...prev.orderId.filter(tag => tag === id)]
      }));
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="custom-modal-backdrop">
        <div className="custom-modal">
          <div className="custom-modal-header">
            <h5 className="modal-title">編輯記錄</h5>
            <button className="btn-close" onClick={(e) => { onClose(null); e.preventDefault(); }}></button>
          </div>

          <div className="custom-modal-body">
            {/* 司機 */}
            <div className="input-group mb-3">
              <span className="input-group-text">司機</span>
              <select
                className="form-select"
                value={form.deliverName}
                onChange={e => setForm(prev => ({
                  ...prev,
                  deliverName: e.target.value,
                  deliverId: e.target.selectedOptions[0].dataset.id
                }))}
              >
                {
                  deliversData.map(deliver =>
                    <option key={deliver.id} data-id={deliver.id} value={deliver.name}>
                      {deliver.name}
                    </option>)
                }

              </select>
            </div>

            {/* 基本資訊 */}
            {EditRecordModalList.map(field => (
              <div className="input-group mb-3" key={field.value}>
                <span className="input-group-text">
                  {field.label}
                  {field.required && <span className="required-star">*</span>}
                </span>
                <input
                  type={field.type}
                  className="form-control"
                  name={field.value}
                  value={field.value === 'deliveryDate' ? formatTaiwanDate(form?.[field.value]) : form?.[field.value]}
                  onChange={handleChange}
                  placeholder={field.placeholder || ""}
                  required={field.required}
                  pattern={field.pattern}
                  title={field.title}
                />
              </div>
            ))}

            {/* 運送狀態 */}
            <div className="input-group mb-3">
              <span className="input-group-text">運送狀態</span>
              <select
                className="form-select"
                value={form.status ? "finish" : "undone"}
                onChange={e => setForm(prev => ({ ...prev, status: e.target.value === "finish" ? 1 : 0 }))}
                required
              >
                <option value="undone">待完成</option>
                <option value="finish">已完成</option>
              </select>
            </div>

            {/* 🔹 新增：標籤欄位 */}
            {tags.length > 0 && (
              <div className="mb-3">
                <span className="input-group-text">標籤</span>
                <div className="tag-container ">
                  {tags.map(tag => (
                    <div key={tag.id} className="tag-item btn btn-sm btn-warning">
                      <span>{tag.id}</span>
                      <button
                        type="button"
                        className="tag-remove-btn"
                        onClick={() => handleRemoveTag(tag.id)}
                      >
                        ×
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}

          </div>

          <div className="custom-modal-footer">
            <button className="btn btn-secondary" onClick={(e) => { onClose(null); e.preventDefault(); }}>取消</button>
            <button className="btn btn-gradient-primary" type="submit">儲存</button>
          </div>
        </div>
      </div>
    </form>
  );
};

export { EditRecordModal };
